module.exports = __webpack_public_path__ + "assets/img/email-86b85dc5.png";